import { messageTemplateService } from '@/services/MessageTemplateService';
import store from '.';
import { MessageTemplate } from '../models';

export interface MessageTemplateState {
  templates: MessageTemplate[];
}

export const messageTemplateModule = {
  state: {
    templates: null,
  },
  mutations: {
    updateMessageTemplate(state: MessageTemplateState, template: MessageTemplate) {
      const index = state.templates.findIndex((c) => c.objectId === template.objectId);
      if (index !== -1) {
        state.templates[index] = {...state.templates[index], ...template};
      }
    },
    addMessageTemplate(state: MessageTemplateState, template: MessageTemplate) {
      state.templates.push(template);
    },
    setMessageTemplates(state: MessageTemplateState, templates: MessageTemplate[]) {
      state.templates = templates;
    },
    deleteMessageTemplate(state: MessageTemplateState, templateId: string) {
      const newMessageTemplates = state.templates.filter((c) => c.objectId !== templateId);
      state.templates = newMessageTemplates;
    },
  },
  actions: {
    async loadMessageTemplates({commit}: {
      commit: (mutation: string, templates: MessageTemplate[]) => void,
    }) {
      if (!store.state.messageTemplate.templates) {
        const templates = await messageTemplateService.getAllMessageTemplates();
        commit('setMessageTemplates', templates);
      }
    },
    async createMessageTemplate({commit}: {
      commit: (mutation: string, templates: MessageTemplate[]) => void,
    },                          payload: MessageTemplate) {
      const template = await messageTemplateService.createMessageTemplate(payload);
      commit('addMessageTemplate', template);
    },
    async updateMessageTemplate({commit}: {
      commit: (mutation: string, template: MessageTemplate) => void,
    },                          template: MessageTemplate) {
      await messageTemplateService.updateMessageTemplate(template.objectId as string, template);
      commit('updateMessageTemplate', template);
    },
    async deleteMessageTemplate({commit}: {
      commit: (mutation: string, templateId: string) => void,
    },                          templateId: string) {
      await messageTemplateService.deleteMessageTemplate(templateId);
      commit('deleteMessageTemplate', templateId);
    },
  },
};
